import styled from "styled-components";
import { theme } from "../../utils/globalStyles/colors";

import ListAltIcon from "@mui/icons-material/ListAlt";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import AnnouncementIcon from "@mui/icons-material/Announcement";
import SettingsApplicationsIcon from "@mui/icons-material/SettingsApplications";

export const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const NavContainerIsAdmin = styled.div`
  width: 90%;
  max-width: 400px; /* Tamanho ideal para web e mobile */
  height: 65px;
  display: flex;
  position: fixed;
  bottom: calc(
    24px + env(safe-area-inset-bottom)
  ); /* Descola do fundo da tela (+ área segura do iPhone) */
  left: 50%;
  transform: translateX(-50%); /* Garante centralização absoluta */
  background-color: #ffffff;
  border-radius: 35px; /* Deixa bem arredondado (pílula) */
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15); /* Sombra suave para destacar */
  z-index: 1000;
  overflow: hidden;
`;

export const ButtonNavIsAdmin = styled.div<{ boolean: boolean }>`
  flex: 1; /* Todos os botões ocupam espaço igual */
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent; /* Remove o fundo que alternava */
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: #f9f9f9;
  }
`;

/* ESTILOS DOS ÍCONES: Laranja quando ativo, cinza quando inativo */
const iconStyles = `
  transition: all 0.2s ease-in-out;
`;

export const NewsIcon = styled(AnnouncementIcon)<{ boolean: boolean }>`
  ${iconStyles}
  color: ${(props) => (props.boolean ? theme.colors.base : "#A0A0A0")};
  font-size: ${(props) =>
    props.boolean
      ? "2.2rem"
      : "1.8rem"} !important; /* Aumenta levemente quando ativo */
`;

export const WalletIcon = styled(AccountBalanceWalletIcon)<{
  boolean: boolean;
}>`
  ${iconStyles}
  color: ${(props) => (props.boolean ? theme.colors.base : "#A0A0A0")};
  font-size: ${(props) => (props.boolean ? "2.2rem" : "1.8rem")} !important;
`;

export const ContactIcon = styled(ListAltIcon)<{ boolean: boolean }>`
  ${iconStyles}
  color: ${(props) => (props.boolean ? theme.colors.base : "#A0A0A0")};
  font-size: ${(props) => (props.boolean ? "2.2rem" : "1.8rem")} !important;
`;

export const EditAccount = styled(SettingsApplicationsIcon)<{
  boolean: boolean;
}>`
  ${iconStyles}
  color: ${(props) => (props.boolean ? theme.colors.base : "#A0A0A0")};
  font-size: ${(props) => (props.boolean ? "2.2rem" : "1.8rem")} !important;
`;
